import React, { useEffect } from "react";

import { isEmpty } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { FilterContext, useFilter } from "../../components/Filter";
import {
    ListView,
    MainPage,
    MainView,
    PageContext,
    usePageState,
} from "../../components/PageLayout";
import { initPeriod } from "../../components/Period";
import { useSideSheet } from "../../components/SideSheet";
import { useUserInfo } from "../../utils/security";
import { fetchPricelistDetail, fetchPricelistList } from "./mock";
import { PricelistsDetail } from "./PricelistsDetail";
import { PricelistsList } from "./PricelistsList";
import { PricelistsOverview } from "./PricelistsOverview";
import { PricelistModal } from "./PricelistModal";

export const PricelistsPage = ({ pagePath }) => {
    const navigate = useNavigate();
    const { id: detailId } = useParams();
    const sideSheet = useSideSheet();
    const { userInfo } = useUserInfo();

    const filterState = useFilter({
        filter: {
            period: initPeriod("year"),
        },
    });
    const { filterValue } = filterState;

    const pageState = usePageState();
    const { state, setListLoading, setList, setDataLoading, setData, isFull } = pageState;
    const isDetailIdSet = !isEmpty(detailId);
    const showList = isFull || !isDetailIdSet;
    const showMain = isFull || isDetailIdSet;

    const addPricelist = () => sideSheet.show({});
    const editPricelist = (data) => sideSheet.show(data || {});

    useEffect(() => {
        const fetchList = async (filter) => {
            setListLoading(true);
            try {
                const data = await fetchPricelistList(filter);
                setList(data);
            } catch (e) {
                console.error(e);
                setList({ error: true });
            } finally {
                setListLoading(false);
            }
        };
        /*
        const fetchOverview = async (filter) => {
            setDataLoading(true);
            try {
                const data = await fetchPricelistOverview(filter);
                setData(data);
            } catch (e) {
                console.error(e);
                setList({ error: true });
            } finally {
                setDataLoading(false);
            }
        };
*/
        fetchList(filterValue);
        //fetchOverview(filterValue);
    }, [filterValue]);

    //fetch loaded data
    useEffect(() => {
        const fetchDetail = async (id) => {
            console.log("fetching detail", id);
            setDataLoading(true);
            try {
                const data = await fetchPricelistDetail(id);
                setData(data);
            } catch (e) {
                console.error(e);
            } finally {
                setDataLoading(false);
            }
        };
        if (!isEmpty(detailId)) {
            fetchDetail(detailId);
        }
    }, [detailId, setData, fetchPricelistDetail]);

    return (
        <>
            <FilterContext.Provider value={filterState}>
                <PageContext.Provider value={pageState}>
                    <MainPage>
                        {showList && (
                            <ListView>
                                <PricelistsList
                                    onAddPricelist={() => sideSheet.show({})}
                                    selectItem={({ id }) => navigate(`/${pagePath}/${id}`)}
                                    loading={state.listLoading}
                                    data={state.list}
                                    detailId={detailId}
                                />
                            </ListView>
                        )}
                        {showMain && (
                            <MainView>
                                {isDetailIdSet ? (
                                    <PricelistsDetail
                                        onEditPricelist={editPricelist}
                                        employeeId={detailId}
                                        onBack={() => navigate(`/${pagePath}`)}
                                        loading={state.dataLoading}
                                        data={state.data}
                                    />
                                ) : (
                                    <PricelistsOverview onAddPricelist={addPricelist} />
                                )}
                            </MainView>
                        )}
                    </MainPage>
                </PageContext.Provider>
            </FilterContext.Provider>

            <PricelistModal
                open={sideSheet.open}
                data={sideSheet.data}
                hide={() => {
                    sideSheet.hide();
                }}
                onTransactionSaved={async (data) => {
                    //await saveTransaction(data);
                    sideSheet.hide();
                    //selectItem();
                }}
                dataLoading={sideSheet.loading}
            />
        </>
    );
};
